//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: "AppArchiveResult",
    props: {
        result: Object
    },
	computed: {
        title() {
            return this.result.document.title.replace(/_/g, ' ').toLowerCase();
        },
        url() {
            if(this.result.document.url)
                return this.result.document.url.substring(1);
            else return '';
        },
        blurb() {
            if(this.result.document.text)
                return this.result.document.text.substring(1, 200);
            else return '';
        },
        supplementalLinks() {
            if(this.result.document.supplementalLinks)
                return '<br/><br/>' + this.result.document.supplementalLinks.substring(0, 500);
            else return '';
        },
        details() {            
            return  this.blurb + this.supplementalLinks  ;
        },

        contentType() {
            if(this.result.document.content)
                return this.result.document.content.substring(1, 200);
            else return '';
        }
    },
    methods: {
        getESTDate(date) {
            var dt = new Date(Date.parse(date));
            var offset = dt.getTimezoneOffset();
            dt.setTime(dt.getTime() + (offset * 60 * 1000));
            //console.log('Result: ', date, new Date(Date.parse(date)), dt, offset);
            if (dt.getFullYear() < 1900) return '';
            return [dt.getMonth()+1, dt.getDate(), dt.getFullYear()].join('/');
        }
    }
};
